// extracted by mini-css-extract-plugin
export var indicatorContainer = "ScrollIndicator-module--indicator-container--zPCpC";
export var indicatorItem = "ScrollIndicator-module--indicator-item--pTSCq";
export var selected = "ScrollIndicator-module--selected--kLVXg";
export var showScrollIndicator = "ScrollIndicator-module--showScrollIndicator--ff43X";